<template>
  <div class="popup">
    <transition name="fade">
      <div class="mask fixed l0 r0 t0 b0 rgba5" v-if="showTag" @click="hide"></div>
    </transition>
    <transition name="fade">
      <div class="main fixed bg_fff l0 r0 b0 flex overflow-y-auto" :class="['level'+level]" v-if="showTag">
        <template v-if="level===2">
          <ul class="flex0 w40 overflow-y-auto">
            <li class="fs16" v-for="(item,index) in data" :key="index" :class="[{bt:index>0,curr:currIndex===index}]"
                @click="currIndex=index">{{item.name}}
            </li>
          </ul>
          <ul class="flex0 w60 overflow-y-auto">
            <li class="fs16" v-for="(item,index) in children" :key="index" :class="[{bt:index>0}]" @click="ok(item)">
              {{item.name}}
            </li>
          </ul>
        </template>
        <template v-else-if="level===1">
          <ul class="flex1">
            <li class="fs16 center" v-for="(item,index) in data" :key="index" :class="[{bt:index>0}]" @click="ok(item)">
              {{item.name}}
            </li>
          </ul>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
  /**
   * @event.popup()
   */
  export default {
    name: 'v-popup',
    data () {
      return {
        showTag: false,
        level: 0,
        data: [],
        currIndex: 0
      }
    },
    computed: {
      children () {
        const {currIndex, data} = this
        if (data.length && data[currIndex].children) {
          return data[currIndex].children
        }
        return []
      }
    },
    methods: {
      show (level, data) {
        this.level = level
        this.data = data
        this.showTag = true
      },
      hide () {
        this.showTag = false
      },
      ok (data) {
        bus.$emit('popup', false, data)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../style/public";

  .fade-enter-active, .fade-leave-active {
    transition: all .3s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(100%);
  }

  .mask {
    z-index: 2000;
  }

  .main {
    z-index: 2100;
    max-height: 70vh;
    &.level2:after {
      content: '';
      display: block;
      position: absolute;
      left: 40%;
      top: 0;
      bottom: 0;
      background-color: $bgColor;
      width: 0.5px;
    }
  }

  li {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .curr {
    color: $mainColor;
  }

  .w40 {
    width: 40%;
  }

  .w60 {
    width: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/v-popup.vue